import { ELKReportName } from '@/types'

interface ELKReportOption {
  // 错误名称或者地址,没有可以传'-'，必传
  name: ELKReportName | string
  // 错误信息
  message: string
  //  错误等级
  grade: 'Info' | 'Warning' | 'Error'
  // 错误类型
  category: 'js' | 'ajax' | 'promise' | 'unknown'
  // 错误堆栈信息,没有可以传'-'
  stack?: string
}

export const elkReport = (reportOption: ELKReportOption) => {
  const { name, message, grade, stack, category } = reportOption
  // 主动上报需要设置详细的配置信息,因为aime的页面也会加载一个skywalking的sdk，会覆盖国内底skywalking的sdk
  const collector = 'https://apm.hexin.cn/skywalking-web/'
  const service = 'zixun_news-c-fe-aiwriter'

  const option = {
    // 采集器服务
    collector,
    // 采样频率
    rate: 1,
    // 业务标识，
    service,
    pagePath: location.pathname,
    serviceVersion: 'aiWriter_1.0', // 格式：业务标识_版本标识
    // 是否考虑SPA的处理，没有用前端路由一定要置为false
    enableSPA: false,
    sendErrorTime: 3000,
    // 链路追踪暂时不接，还没有打通
    noTrace: true,
  }

  ;(window as any).ClientMonitor &&
    (window as any).ClientMonitor.reportFrameErrors(
      {
        ...option,
        category,
        grade,
      },
      {
        name,
        message,
        stack: stack ?? '-',
      },
    )
}
